import React, { Fragment, useEffect, useState } from 'react';
import { flip, offset, shift, size, useFloating } from '@floating-ui/react-dom';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import rafSchd from 'raf-schd';
import { Portal } from '../../Portal/index.js';
import { useFloatingContext } from './FloatingContext.js';
import { useUpdateOnScroll } from './useUpdateOnScroll.js';
export const FloatingWrapper = ({ open, sameWidth = false, skipTransition = false, children, }) => {
    var _a, _b;
    const { placement, triggerRef } = useFloatingContext();
    const [sizeData, setSizeData] = useState(null);
    const middleware = [
        offset(4),
        shift(),
        flip({
            fallbackStrategy: 'initialPlacement',
        }),
    ];
    if (sameWidth) {
        middleware.push(size({ apply: setSizeData }));
    }
    const { x, y, reference, floating, strategy, update } = useFloating({
        placement,
        middleware,
    });
    useEffect(() => {
        reference(triggerRef.current);
    }, [reference, triggerRef]);
    useUpdateOnScroll(triggerRef, update, 'scroll');
    useUpdateOnScroll(triggerRef, update, 'resize');
    useEffect(() => {
        const schedule = rafSchd(update);
        if (open) {
            schedule();
        }
        return () => schedule === null || schedule === void 0 ? void 0 : schedule.cancel();
    }, [update, open, children]);
    if (!open) {
        return null;
    }
    const style = {
        position: strategy,
        top: '0',
        left: '0',
        transform: `translate(${Math.round(x)}px,${Math.round(y)}px)`,
    };
    if (sameWidth) {
        style.width = (_a = sizeData === null || sizeData === void 0 ? void 0 : sizeData.reference.width) !== null && _a !== void 0 ? _a : '';
        style.maxWidth = (_b = sizeData === null || sizeData === void 0 ? void 0 : sizeData.reference.width) !== null && _b !== void 0 ? _b : '';
    }
    const content = skipTransition ? (children) : (React.createElement(Transition, { show: open, as: Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" }, children));
    return (React.createElement(Portal, null,
        React.createElement("div", { ref: floating, style: style, className: clsx(!skipTransition && x === null && 'invisible') }, content)));
};
//# sourceMappingURL=FloatingWrapper.js.map